module.exports = __webpack_public_path__ + "img/无数据.95461814.png";